import React from "react";
import { I18n } from "../../../../models/I18n";
import ReportSummarySection from "../ReportSummarySection/ReportSummarySection";
import ResultColorBar from "../ResultColorBar/ResultColorBar";
import { ReportSummaryColors } from "../../constants/ReportSummaryColors";
import { camelCaseToSnakeCase } from "../../../../utils/camelCaseToSnakeCase";
import { RiskIndicator } from "../../constants/RiskIndicator";
import style from "./style/AbilityToChangeSummary.module.scss";

interface AbilityToChangeSubScore {
    outcome: RiskIndicator;
    handle: string;
}

export interface AbilityToChangeSummaryProps {
    title: string;
    basedOn: string;
    handle: string;
    outcome: RiskIndicator;
    scrollToSection?: (elementId: string) => void;
    scores: AbilityToChangeSubScore[];
    i18n: I18n;
    classes?: {
        titleDecoration: string;
    }
}

const AbilityToChangeSummary = ({
    title,
    basedOn,
    handle,
    outcome,
    scrollToSection,
    scores,
    i18n,
    classes,
}: AbilityToChangeSummaryProps) => {
    const getResultText = () => {
        const risks = scores
            .filter((score) => score.outcome === RiskIndicator.RISKY)
            .map((score) => i18n[`report_${camelCaseToSnakeCase(score.handle)}`]);
        const risksText = risks.join(", ");

        let subText;

        if (!risks.length) {
            subText = <p>{i18n.report_management_summary_ability_to_change_no_risk_definition}</p>;
        } else {
            subText = (
                <p>
                    {i18n.report_management_summary_ability_to_change_risky_definition} <strong>{risksText}</strong>
                </p>
            );
        }

        return (
            <div className={style.abilityToChangeOutcomeText}>
                <p>
                    <strong>{i18n[`report_management_summary_ability_to_change_${outcome}_outcome`]}</strong>
                </p>
                {subText}
            </div>
        );
    };

    const getResultColor = () => {
        if (!outcome) {
            return null;
        }
        return outcome === RiskIndicator.RISKY ? ReportSummaryColors.ORANGE : ReportSummaryColors.GREEN;
    };

    return (
        <ReportSummarySection
            basedOn={basedOn}
            handle={handle}
            i18n={i18n}
            scrollToSection={scrollToSection ? scrollToSection : null}
            showViewAll={!!scrollToSection}
            title={title}
            classes={classes || { titleDecoration: "" }}
        >
            <ResultColorBar color={getResultColor()} text={getResultText()} />
        </ReportSummarySection>
    );
};

export default AbilityToChangeSummary;
